import { Theme } from '@mui/material';
/**
 * CcfCustomerCard - used to display quick replies component
 * @param props -?-customerCardDetailsStyles
 * @example <customerCardDetailsStyles />
 */
const customerCardStyles = (theme: Theme) => {
  const styles = {
    customerCardContainer: {
      width: '100%',
      [theme.breakpoints.down('xl')]: {
        marginLeft: '0px',
        overflow: 'auto',
      },
      [theme.breakpoints.up('xl')]: {
        marginLeft: '0px',
        height: '100%',
        overflow: 'auto',
      },
      height: '100%',
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: '0.4em',
      },
    },
    accordionContainer: {
      boxShadow: 'none',
      display: 'block',
    },
    ccfAppSpaceAccordionHeader: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      
    },
    accordionHeaderExpand: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      borderTop: `solid ${theme.palette.background.default} 1px`,
      boxShadow: '0px -1px 1px #e7eaec',
    },
    accordionHeaderActivityExpand: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      borderTop: `solid ${theme.palette.background.default} 1px`,
      boxShadow: `-1px 1px 1px ${theme.palette.background.toastBackground}`,
    },
    contactCardDetailsContainer: {
      maxHeight: '150px',
      overflowY: 'auto',
      paddingLeft: '20px',
    },
    expandedIcon: {
      transform: 'rotate(180deg)',
      height: '24px',
      width: '24px',
      color: `#5B7C8C`,
    },
    contactCardTitle: {
      font: `normal normal 600 14px/${theme.typography.h5.fontSize} ${theme.typography.fontFamily}`,
      letterSpacing: '0px',
      color: theme.palette.text.primary,
      opacity: 1,
    },
    customerNoteParent:{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    hideAccordion: {
      display: 'none',
    },
    mergeIcon: {
      position: 'absolute',
      right: theme.spacing(1),
    },
    ccAlert: {
      position: 'sticky', 
      bottom: 0, 
      width: '100%',
    },
    notesAccordionTitle:{
      fontWeight: '600',
    },
    selectDropdown: {
      width: '100px !important',
      height: '17px !important',
      background:
        'rgba(228, 228, 228, 0.6) 0% 0% no-repeat padding-box !important',
      borderRadius: '5px !important',
      font: 'normal normal bold 11px/15px Open Sans !important',
      letterSpacing: '0px !important',
      color: '#616c75 !important',
      textTransform: 'uppercase',
      padding: '4px 10px !important',
      // @include rtlOnly('text-align', right !important),
      // @include ltrOnly('text-align', left !important),
    },
  };
  return styles;
};
export default customerCardStyles;
